import React from 'react';

export default function ProfilSiswa() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Profil Siswa</h1>
      <p className="text-gray-500">Halaman Profil Siswa</p>
    </div>
  );
}
